import { formatterWithUsd } from '../utils';

export const getMonth = ({ months_com, index }) =>
  months_com?.[months_com.length - index];

export const getAer = data => data?.aer && formatterWithUsd(data.aer);

export const getCom = data => data?.com && `${data.com.toFixed(2)}%`;
